import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import ButtonViewImpact from './PropertiesPaneButtonViewImpact.jsx'
import Model from './ModelIsrf.mjs'

export default function PropertiesPaneIsrf(props) {
    return (
        <ProductPropertiesPane
            buttons={<ButtonViewImpact />}

            controllers={
                <>
                    <Text prop="dpSn" />
                    <Text prop="isrfName" />
                    <Text prop="reqNo" />
                    <LongText prop="memo" />
                </>
            }

            Model={Model}
            sn={null}
            {...props}
        />
    )
}
